<script setup lang="ts">
import { initAccordions } from 'flowbite'
import ExpandableItem from '~/components/banner/accordion/ExpandableItem.vue'
import { translate } from '~/composables/translate/translations'

interface Faq { question: string, answer: string }

onBeforeMount(() => {
  initAccordions()
  buildQuestionsAndAnswers()
})

const questions: Faq[] = []

function buildQuestionsAndAnswers(questionsCount = 5) {
  const prefix = 'extra_faq'
  for (let index = 1; index <= questionsCount; index++) {
    questions.push({
      question: translate(`${prefix}_${index}_question`),
      answer: translate(`${prefix}_${index}_answer`),
    })
  }
}
</script>

<template>
  <section class="my-36 lg:mb-[120px] xs:mb-8 py-36 px-36 decorative-shadows rounded-lg" data-testid="faq-section">
    <h3 class="mb-24 text-black-100">
      {{ translate('extra_faq_title') }}
    </h3>

    <div id="accordion-collapse" data-accordion="collapse">
      <ExpandableItem
        v-for="(item, index) in questions"
        :key="index"
        :index="index"
        :total="questions.length"
        :question="item.question"
        :answer="item.answer"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.decorative-shadows {
  box-shadow: 0 5px 10px rgb(0 0 0 / 5%);
}
</style>
